'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import React from 'react';
import { EColors, ECountries } from '@/_types';
import { Divider } from '@/_kit/divider';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import { BrowserLink } from '@/_kit/browser-link';
import { TitleWrapper } from './_components/title-wrapper';
import { Card } from './_components/card';
import { THowToStartConfig } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'HowToStart';

export const HowToStart = ({
  downloadPdf,
  titleWrapper,
  cards,
  pdfLink,
  country,
}: THowToStartConfig) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const isShowButton =
    country === ECountries.RU ||
    country === ECountries.ZH ||
    country === ECountries.KZ;
  const isGeCountry = country === ECountries.GE;

  const handleDownloadPdf = () => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_STEPS_TO_START_T,
    };

    sendEvent(config);
  };

  // eslint-disable-next-line @portals/custom-plugin/todo-checker
  // TODO: make animation-block sticky
  return (
    <section className={cn(BLOCK_NAME)} id="howStart">
      <div className={cn(`${BLOCK_NAME}__content`)}>
        <div className={cn(`${BLOCK_NAME}__animation-block`)} />
        <div
          className={cn(`${BLOCK_NAME}__layout`, {
            [`${BLOCK_NAME}__layout--ge`]: isGeCountry,
          })}
        >
          <div className={cn(`${BLOCK_NAME}__layout-content`)}>
            <TitleWrapper
              {...titleWrapper}
              onDownloadPdf={handleDownloadPdf}
              pdfLink={pdfLink}
              country={country}
            />
            <div className={cn(`${BLOCK_NAME}__divider`)}>
              <Divider color={EColors.TEXT_SECONDARY} />
            </div>
            <div className={cn(`${BLOCK_NAME}__cards`)}>
              {cards.map((props) => (
                <Card key={props.id} {...props} country={country} />
              ))}
            </div>
          </div>
          {isShowButton && (
            <div className={cn(`${BLOCK_NAME}__link`)}>
              <BrowserLink
                color={EColors.BLUE_500}
                onClick={handleDownloadPdf}
                rel="noopener noreferrer"
                routeName={pdfLink}
                target="_blank"
              >
                <Text
                  size={ETextSize.SMALL}
                  text={translations(downloadPdf)}
                  variant="body"
                />
              </BrowserLink>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
